import { Box } from "@mui/material";
import { ReactComponent as VerizonLogoLatest } from "../assets/Verizon_logo-latest.svg";

export function LegalDisclaimer() {
  const normalQStyle = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "left",
      width: "95%",
      height: "90px",
      margin: "10px",
    },
    imageAndTextContainer: {
      backgroundColor: "#F6F6F6",
      border: 3,
      borderColor: "red",
      display: "flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      margin: 5,
    },
    image: {
      width: "10%",
      height: "25%",
      margin: 20,
      marginLeft: "7%",
      marginRight: "5%",
    },
    text: { margin: 10, fontSize: 14 },
  };

  return (
    <div style={normalQStyle.container}>
      <Box
        width={"70%"}
        height={"fit-content"}
        sx={normalQStyle.imageAndTextContainer}
      >
        <VerizonLogoLatest />
        <h5 style={normalQStyle.text}>
          <b>Content is For Discussion Purposes Only:</b>
          &nbsp; Verizon makes no representation that it can or will provide the
          proposed product/service/features depicted in this demonstration at
          any specific time in the future or at all.
        </h5>
      </Box>
    </div>
  );
}
